/**
 * 小程序信息
 */
type BannerJumpInfo = H5JumpInfo | MiniAppJumpInfo;

export type H5JumpInfo = {
  /** H5跳转活动url */
  jumpUrl: string;
};

export type MiniAppJumpInfo = {
  /** 小程序appid , appid和 username 二选一*/
  miniAppId?: string;
  /** 小程序username , appid和 username 二选一 */
  miniAppUsername?: string;
  /** 小程序页面路径 */
  miniAppPath: string;
};

/**
 * banner配置
 */
export interface BannerConfig {
  /* banner图片地址 */
  bannerImgUrl: string;
  /* banner的tag，用于bi上报区分 */
  bannerTag: string;
  /** 排序权重 */
  weight: number;
  /** 点击banner跳转信息 */
  bannerJumpInfo?: BannerJumpInfo;
  /** 无障碍 */
  bannerAlt?: string;
  /* banner上下架时间，若未传入的时候，则认为是长期有效 */
  bannerTime?: {
    /* banner上架时间 */
    startTime: Date;
    /* banner下架时间 */
    endTime: Date;
  };
  /** 额外传入数据 */
  extraData?: any
}
/**
 * 配置转换
 */
export type ConfigTransformer = <T extends BannerConfig[]>(arg: T) => T;
/**
 * Banner类型
 * tile: 平铺 ｜ Swiper: 轮播
 */
export enum BannerType {
  /** 平铺 */
  tile = 'tile',
  /** 轮播 */
  swiper = 'swiper',
  /** 小程序swiper */
  mpSwiper = 'mp-swiper',
}
